import React, { FC, useEffect, useRef, useState, useCallback } from "react";
import { Box, SxProps, Theme } from '@mui/material';
import QRCodeStyling, { Options as QrCodeOptions } from 'qr-code-styling';
import { clsx } from '../../utils';
import { Colors } from '../../constants';

export type CoreQrCodeProps = {
	link: string;
	size?: number;
	qrCodeOptions?: QrCodeOptions;
	rootSx?: SxProps<Theme>;
	qrCodeSx?: SxProps<Theme>;
};

export const CoreQrCode: FC<CoreQrCodeProps> = (props) => {
	const {
		link,
		size = 300,
		qrCodeOptions = {},
		qrCodeSx,
	} = props;

	const qrRef = useRef(null);

	const [qrCode, setQrCode] = useState<QRCodeStyling | null>(null);

	const generateQrCode = useCallback(async () => {
		const qrCode = new QRCodeStyling({
			width: size,
			height: size,
			dotsOptions: {
				color: Colors['393739'],
				type: "extra-rounded",
			},
			cornersSquareOptions: {
				color: Colors['110A20'],
				type: "extra-rounded",
			},
			...qrCodeOptions,
		});

		setQrCode(qrCode);

		if (qrRef.current) {
			qrCode.append(qrRef.current);
		}
	}, []);

	useEffect(() => {
		generateQrCode();
  }, [generateQrCode]);

	useEffect(() => {
		qrCode?.update({
			data: link
		});
	}, [qrCode, link]);

	return (
		<Box
			sx={clsx(
				{
					backgroundColor: Colors.white,
					padding: '5px',
					borderRadius: '20px',
					overflow: 'hidden',
				},
				qrCodeSx,
			)}
		>
			<div ref={qrRef} style={{ height: size, width: size }} />
		</Box>
	);
}
